export function QuantityStepper({
  value,
  onChange,
  min = 0,
  max = 99,
}: {
  value: number;
  onChange: (next: number) => void;
  min?: number;
  max?: number;
}) {
  return (
    <div className="flex items-center border border-stroke">
      <button
        type="button"
        aria-label="Зменшити кількість"
        disabled={value <= min}
        onClick={() => onChange(value - 1)}
        className="btn-press px-3 py-2 text-ink disabled:opacity-40"
      >
        −
      </button>
      <span className="min-w-8 text-center font-mono text-[13px] text-ink">{value}</span>
      <button
        type="button"
        aria-label="Збільшити кількість"
        disabled={value >= max}
        onClick={() => onChange(value + 1)}
        className="btn-press px-3 py-2 text-ink disabled:opacity-40"
      >
        +
      </button>
    </div>
  );
}
